import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { StepButtonsProps } from 'src/modules/programs/components/StepButtons';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import * as S from 'src/modules/programs/stepComponents/styles';
import { SimpleSurveyStep } from 'src/modules/programs/surveys/stepComponents/SimpleSurveyStep';

import { CBTProgramWeekSixSurvey } from '../models/weekSix';

interface Props extends StepButtonsProps, WithTranslation {
    programId: ProgramEnum;
}

export const HowDidCognitiveFlexibilityGoStep = withTranslation('cbt')((props: Props) => (
    <SimpleSurveyStep
        {...props}
        programId={props.programId}
        surveyId={CBTProgramWeekSixSurvey.HowDidCognitiveFlexibilityGo}
        heading={
            <>
                <S.StepHeading>
                    {props.t('week-6.how-did-cognitive-flexibility-go.title')}
                </S.StepHeading>
                <S.StepDescription small>
                    {props.t('week-6.how-did-cognitive-flexibility-go.description')}
                </S.StepDescription>
            </>
        }
    />
));
